import moment from "moment";
import { BbotTable } from "top-component-library";

import { Section } from "../styles";
import { formatCents } from "../utils";

const PAGINATION_CONFIG = {
  defaultPageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ["5", "10", "20", "50"],
};

const MessageHistoryTable = ({ texts, showCost }) => {
  const columns = [
    {
      title: "Date",
      dataIndex: "time",
      key: "time",
      render: (time) => moment(time).format("MM/DD/YYYY [at] h:mm A"),
    },
    { title: "Receiving Number", dataIndex: "to_number", key: "to_number" },
    { title: "Message", dataIndex: "body", key: "body" },
    ...(showCost
      ? [{ title: "Cost", dataIndex: "debit_cents", key: "debit_cents", render: (cents) => formatCents(cents) }]
      : []),
  ];

  const data = texts.map((message, index) => ({ ...message, key: index }));

  return (
    <Section>
      <BbotTable
        id="text-message-history"
        title="Text Message History"
        manuallyFormattedColumns={columns}
        data={data}
        pagination={PAGINATION_CONFIG}
      />
    </Section>
  );
};

export default MessageHistoryTable;
